import * as React from 'react';
import { TransactionHistoryRowComponent } from './transactionhistoryrowcomponent';
import { PaginationListViewModelImpl } from '../../../../toolkit/verticallist/paginationverticallist/paginationlistviewmodel';
import { TransactionHistoryDto } from '../../../../../core/dto/transactionhistory/transactionhistorydto';
import { EnglishTransactionHistoryRowCSSStyle } from './transactionhistoryrowcss';
import './history-style.css';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import { LanguageConst } from 'src/com/sixdee/crbtportal/utils/resources/languageconst';

export class TransactionHistoryViewModelImpl extends PaginationListViewModelImpl<TransactionHistoryDto>
{

    cssStyle:EnglishTransactionHistoryRowCSSStyle;
   
    getView(t: TransactionHistoryDto, position: number): boolean | JSX.Element 
    {
        return <TransactionHistoryRowComponent key={position}  context={this.getContext()} transactionHistoryDto={t}  position={position}/>;
    }

    getHeader():boolean|JSX.Element
    {
        return(
            <tr  id="List-view" style={{width:'100%', height:'40px', flexFlow: "row wrap",flexDirection:'row',marginLeft:'4.5%',marginRight:'4.5%'}}>
   

                 <th id='header1' style={{height:'50px',lineHeight:'40px', textAlign:'left',color:'#6D6D6D',}}>
                        <label style={{ minWidth:'60px',fontFamily:this.getContext().getResources().getFontFamily(), letterSpacing:'0',overflow: 'hidden',textOverflow: 'ellipsis', fontSize:this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH?'15px':"13px",fontWeight:500}}>
                        {this.getContext().getResources().getString(Strings.tunename)}
                        </label>
                </th>
                <th id='header2' style={{height:'50px',lineHeight:'40px',textAlign:'left',color:'#6D6D6D',}}>
                        <label style={{ minWidth:'60px', fontFamily:this.getContext().getResources().getFontFamily(), letterSpacing:'0',fontWeight:500,overflow: 'hidden',textOverflow: 'ellipsis', fontSize:this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH?'15px':"13px"}}>
                        {this.getContext().getResources().getString(Strings.date_time)}
                        </label>
                </th>
                <th id='header3' style={{marginLeft:'5px',height:'50px',lineHeight:'40px',textAlign:'left',color:'#6D6D6D',}}>
                        <label style={{minWidth: "40px",textAlign:'left', fontFamily:this.getContext().getResources().getFontFamily(),fontWeight:500, letterSpacing:'0',fontSize:this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH?'15px':"13px",overflow: 'hidden',textOverflow: 'ellipsis',}}>
                        {this.getContext().getResources().getString(Strings.price)}
                        </label>
                </th>
                <th id='header4' style={{height:'50px',marginLeft:'0px',lineHeight:'40px',textAlign:'left',color:'#6D6D6D',}}>
                        <label style={{minWidth: "40px",textAlign:'left', fontFamily:this.getContext().getResources().getFontFamily(),fontWeight:500 ,letterSpacing:'0',fontSize:this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH?'15px':"13px",overflow: 'hidden',textOverflow: 'ellipsis',}}>
                        {this.getContext().getResources().getString(Strings.validity)}
                        </label>
                </th>
                <th id='header5' style={{marginRight:'0px',height:'50px',lineHeight:'40px',textAlign:'left',color:'#6D6D6D',}}>
                        <label style={{ minWidth:'60px', fontFamily:this.getContext().getResources().getFontFamily(), letterSpacing:'0',fontWeight:500,overflow: 'hidden',textOverflow: 'ellipsis', fontSize:this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH?'15px':"13px"}}>
                        {this.getContext().getResources().getString(Strings.transaction_type)}
                        </label>
                </th>
                <th id='header6'  style={{marginLeft:'0px',height:'50px',lineHeight:'40px',textAlign:'left',}}>
                        <label style={{color:'#6D6D6D', minWidth:'40px',margin:' 0px',fontWeight:500,fontFamily:this.getContext().getResources().getFontFamily(), letterSpacing:'0',overflow: 'hidden',textOverflow: 'ellipsis', fontSize:this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH?'15px':"13px"}}>
                        {this.getContext().getResources().getString(Strings.channel_type)}
                        </label>
                </th>
              
            </tr>
        );
    }


}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/transactionhistory/viewmodel/transactionhistoryviewmodel.tsx